(() => {
  const PARAM_FOR = {
    caps: 'capsules',
    biotics: 'biotics',
    chew: 'chewables',
    'chew-nas': 'no-added-sugar',
    powder: 'powder'
  };
  const GROUP_FOR = {
    caps: 'fmt-caps',
    biotics: 'fmt-caps',
    chew: 'fmt-chew',
    'chew-nas': 'fmt-chew',
    powder: 'fmt-powder'
  };
  const root = document.documentElement;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const currentKey = () => root.getAttribute('data-pl-opt');

  const showsFor = (el, key) => {
    const tokens = (el.getAttribute('data-pl-show') || '').split(/\s+/).filter(Boolean);
    return !tokens.length || tokens.includes(key) || tokens.includes(GROUP_FOR[key]);
  };

  const clarity = (...args) => {
    window.clarity = window.clarity || function queue() {
      (window.clarity.q = window.clarity.q || []).push(arguments); // eslint-disable-line prefer-rest-params
    };
    window.clarity(...args);
  };

  if (!customElements.get('phloe-lp-box')) {
    class PhloeLpBox extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        this.config = JSON.parse(this.querySelector('[data-pl-config]').textContent);
        const sid = this.dataset.sectionId;
        this.names = {
          fmt: `pl-fmt-${sid}`,
          chew: `pl-chew-${sid}`,
          qty: `pl-qty-${sid}`,
          purchase: `pl-purchase-${sid}`
        };

        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('[name="id"]');
        this.qtyInput = this.form.querySelector('[name="quantity"]');
        this.planInput = this.form.querySelector('[data-pl-plan]');
        this.submitBtn = this.form.querySelector('[name="add"]');
        this.labelEl = this.querySelector('.pl-cta__label');
        this.busyEl = this.querySelector('[data-pl-busy]');
        this.upgradeInput = this.querySelector('[data-pl-upgrade]');
        this.purchase = this.querySelector('[data-pl-purchase]');
        this.onceInput = this.querySelector(`[name="${this.names.purchase}"][value="once"]`);
        this.subInput = this.querySelector('[data-pl-sub-input]');
        this.status = this.querySelector('[data-pl-status]');
        this.appstleBridge = this.querySelector('[data-pl-appstle-bridge] input');
        this.afterpay = this.querySelector('square-placement');

        this.busyLabel = null;
        this.lastKey = null;
        this.wantSub = Boolean(this.subInput && this.subInput.checked);

        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('submit', this.handleSubmit.bind(this), true);
        this.addEventListener('on:cart:add', this.handleAdded.bind(this));
        this.addEventListener('on:line-item:change', this.handleAdded.bind(this));
        this.addEventListener('on:cart:error', this.endBusy.bind(this));
        window.addEventListener('pageshow', this.handlePageShow.bind(this));
        document.addEventListener('click', this.handleDocumentClick.bind(this));

        this.guardSubscriptionWidget();
        this.disableUpsellPopup();
        this.render(false);
        clarity('set', 'landing', 'phloe');
      }

      firstInGroup(group) {
        return Object.keys(this.config.options).find((key) => this.config.options[key].group === group);
      }

      readState() {
        const checked = (name) => this.querySelector(`[name="${name}"]:checked`)?.value;
        const fmt = checked(this.names.fmt);
        let key;
        if (fmt === 'fmt-chew') {
          key = checked(this.names.chew);
          if (!this.config.options[key]) key = this.firstInGroup('fmt-chew');
        } else if (fmt === 'fmt-powder') {
          key = 'powder';
        } else {
          key = this.upgradeInput && this.upgradeInput.checked ? 'biotics' : 'caps';
          if (!this.config.options[key]) key = this.firstInGroup('fmt-caps');
        }
        if (!this.config.options[key]) key = this.config.default;

        const qty = Number(checked(this.names.qty));
        return {
          key,
          qty: qty >= 1 && qty <= 3 ? qty : this.config.defaultQty,
          sub: checked(this.names.purchase) === 'sub'
        };
      }

      getSelection() {
        const state = this.readState();
        const option = this.config.options[state.key];
        const q = option.q[state.qty - 1];
        const subAvailable = Boolean(this.config.subscribe && this.purchase && q.sub);
        const sub = state.sub && subAvailable ? q.sub : null;
        return {
          ...state,
          option,
          q,
          subAvailable,
          sub,
          total: sub ? sub.total : q.total,
          amount: sub ? sub.amount : q.amount
        };
      }

      handleChange(evt) {
        if (!evt.target.closest('.pl-box__input, [data-pl-upgrade]')) return;
        if (evt.target.name === this.names.purchase) this.wantSub = evt.target.value === 'sub';
        this.render(true);
        this.announce();
      }

      // The option a compare card's "Buy now" link selects, or null if the buy box doesn't have it (the link then loads normally).
      resolvePick(key) {
        if (key === 'chew') {
          const current = this.querySelector(`[name="${this.names.chew}"]:checked`)?.value;
          return this.config.options[current] ? current : this.firstInGroup('fmt-chew') || null;
        }
        return this.config.options[key] ? key : null;
      }

      handleDocumentClick(evt) {
        const bundle = evt.target.closest('[data-pl-bundle-add]');
        if (bundle) {
          evt.preventDefault();
          this.addBundle(bundle);
          return;
        }
        const link = evt.target.closest('a[data-pl-pick]');
        if (link) {
          const key = this.resolvePick(link.dataset.plPick);
          if (!key) return;
          evt.preventDefault();
          this.pick(key);
          return;
        }
        const add = evt.target.closest('[data-pl-add]');
        if (add && !this.contains(add)) {
          evt.preventDefault();
          if (!this.submitBtn.disabled) this.form.requestSubmit(this.submitBtn);
        }
      }

      pick(key) {
        const option = this.config.options[key];
        const check = (selector) => {
          const input = this.querySelector(selector);
          if (input) input.checked = true;
        };
        check(`[name="${this.names.fmt}"][value="${option.group}"]`);
        if (option.group === 'fmt-chew') check(`[name="${this.names.chew}"][value="${key}"]`);
        if (this.upgradeInput) this.upgradeInput.checked = key === 'biotics';
        this.render(true);
        this.announce();

        const target = this.closest('#buy') || this;
        target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        const radio = this.querySelector(`[name="${this.names.fmt}"]:checked`);
        if (radio) radio.focus({ preventScroll: true });
      }

      handlePageShow(evt) {
        if (evt.persisted) {
          this.endBusy();
          clearTimeout(this.bundleTimer);
          document.querySelectorAll('[data-pl-bundle-add]').forEach((btn) => {
            btn.removeAttribute('aria-busy');
            this.setBundleBusy(btn, null);
          });
        }
        this.render(false);
      }

      handleSubmit() {
        if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;
        this.render(false);
        this.submitKey = this.readState().key;
        this.setBusy('Adding…');
        this.busyTimer = setTimeout(() => {
          if (this.submitBtn.getAttribute('aria-disabled') !== 'true') this.endBusy();
        }, 10000);
      }

      handleAdded() {
        this.setBusy('Added to cart');
        this.busyTimer = setTimeout(() => this.endBusy(), 1400);
        this.tagCart();
      }

      setBusy(label) {
        clearTimeout(this.busyTimer);
        clearTimeout(this.announceTimer);
        this.busyLabel = label;
        this.status.textContent = label;
        this.render(false);
      }

      endBusy() {
        clearTimeout(this.busyTimer);
        if (!this.busyLabel) return;
        this.busyLabel = null;
        this.render(false);
      }

      render(fromUser) {
        if (this.subInput) {
          const { subAvailable } = this.getSelection();
          if (!subAvailable && this.subInput.checked) {
            this.onceInput.checked = true;
          } else if (subAvailable && this.wantSub && !this.subInput.checked) {
            this.subInput.checked = true;
          }
        }
        const sel = this.getSelection();
        const keyChanged = sel.key !== this.lastKey;
        const soldOut = !sel.option.available;

        if (this.purchase) this.purchase.hidden = !sel.subAvailable;

        if (currentKey() !== sel.key) root.setAttribute('data-pl-opt', sel.key);
        if (fromUser && keyChanged) this.syncUrl(sel.key);

        this.idInput.value = sel.option.variant;
        this.qtyInput.value = sel.qty;
        this.planInput.value = sel.sub ? sel.sub.plan : '';
        this.planInput.disabled = !sel.sub;
        if (this.appstleBridge && this.busyLabel !== 'Adding…') {
          this.appstleBridge.value = this.planInput.value;
        }

        this.submitBtn.disabled = soldOut;
        document.querySelectorAll('[data-pl-add]').forEach((btn) => {
          btn.disabled = soldOut;
        });
        const bundleItem = this.bundleItem(sel.key);
        document.querySelectorAll('[data-pl-bundle-add]').forEach((btn) => {
          btn.disabled = !bundleItem || bundleItem.dataset.available !== 'true';
        });
        const override = this.busyLabel || (soldOut ? 'Sold out' : null);
        this.labelEl.hidden = Boolean(override);
        this.busyEl.hidden = !override;
        this.busyEl.textContent = override || '';

        if (this.afterpay) this.afterpay.setAttribute('data-amount', sel.amount);

        const binds = {
          summary: `${sel.option.name} · ${sel.q.units}`,
          total: sel.total,
          months: sel.q.monthsText,
          cta: soldOut ? 'Sold out' : `Buy ${sel.q.units} · ${sel.total}`
        };
        document.querySelectorAll('[data-pl-bind]').forEach((el) => {
          const text = binds[el.dataset.plBind];
          if (text !== undefined && el.textContent !== text) el.textContent = text;
        });

        document.querySelectorAll('a[data-pl-pick]').forEach((link) => {
          const key = link.dataset.plPick;
          const current = key === sel.key || (key === 'chew' && sel.option.group === 'fmt-chew');
          if (current) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        if (keyChanged || fromUser) {
          document.dispatchEvent(
            new CustomEvent('on:phloe-lp:change', {
              detail: { key: sel.key, qty: sel.qty, sub: Boolean(sel.sub), fromUser, keyChanged }
            })
          );
        }
        if (keyChanged) clarity('set', 'landing_format', sel.key);
        this.lastKey = sel.key;
      }

      syncUrl(key) {
        if (window.Shopify && window.Shopify.designMode) return;
        const url = new URL(window.location.href);
        if (url.searchParams.get('option') === PARAM_FOR[key]) return;
        url.searchParams.set('option', PARAM_FOR[key]);
        window.history.replaceState(window.history.state, '', url);
      }

      announce() {
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => {
          const sel = this.getSelection();
          const plan = sel.sub ? `subscribe every ${sel.q.monthsText}` : 'one-time';
          const price = sel.option.available ? sel.total : 'sold out';
          this.status.textContent = `${sel.option.name}, ${sel.q.units}, ${plan}, ${price}`;
        }, 600);
      }

      tagCart(extra = {}) {
        const attributes = { ...extra };
        if (!this.tagged) {
          this.tagged = true;
          attributes._landing = 'phloe';
          attributes._landing_format = this.submitKey || this.readState().key;
        }
        if (!Object.keys(attributes).length) return Promise.resolve();
        return fetch(`${theme.routes.cartUpdate}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        }).catch(() => {});
      }

      bundleItem(key) {
        return [...document.querySelectorAll('[data-pl-bundle-item]')].find((el) => showsFor(el, key));
      }

      setBundleBusy(btn, text) {
        const label = btn.querySelector('[data-pl-bundle-label]');
        const busy = btn.querySelector('[data-pl-bundle-busy]');
        label.hidden = Boolean(text);
        busy.hidden = !text;
        busy.textContent = text || '';
      }

      async addBundle(btn) {
        if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        const key = this.readState().key;
        const item = this.bundleItem(key);
        if (!item || item.dataset.available !== 'true') return;

        const error = btn.parentElement.querySelector('[data-pl-bundle-error]');
        const drawer = document.querySelector('cart-drawer');
        const sections = ['cart-icon-bubble'];
        if (drawer) sections.push(drawer.closest('.shopify-section').id.replace('shopify-section-', ''));
        const ids = [item.dataset.variant, ...JSON.parse(btn.dataset.plBundleAdd)];

        clearTimeout(this.bundleTimer);
        btn.setAttribute('aria-busy', 'true');
        this.setBundleBusy(btn, 'Adding…');
        if (error) error.hidden = true;
        if (this.appstleBridge) this.appstleBridge.value = '';

        let message = 'The bundle couldn’t be added. Please try again.';
        try {
          const response = await fetch(`${theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
              sections: sections.join(','),
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) {
            const reason = typeof data.description === 'string' ? data.description : data.message;
            if (reason) message = reason;
            throw new Error(response.status);
          }

          this.submitKey = key;
          const tagged = this.tagCart({ _landing_bundle: btn.dataset.plBundleName });
          clarity('event', 'phloe_bundle_add');

          if (theme.settings.afterAtc === 'page' || theme.settings.afterAtc === 'no-js') {
            await tagged;
            window.location.href = theme.routes.cart;
            return;
          }
          customElements.get('product-form')?.updateCartIcon(data);
          if (drawer) drawer.renderContents(data, theme.settings.afterAtc === 'drawer');

          this.status.textContent = 'Bundle added to cart';
          this.setBundleBusy(btn, 'Added to cart');
          this.bundleTimer = setTimeout(() => this.setBundleBusy(btn, null), 1400);
        } catch {
          if (error) {
            error.textContent = message;
            error.hidden = false;
          }
          this.setBundleBusy(btn, null);
        } finally {
          btn.removeAttribute('aria-busy');
          this.render(false);
        }
      }

      disableUpsellPopup() {
        window.OCUApi = window.OCUApi || {};
        window.Zipify = window.Zipify || {};
        window.Zipify.OCU = window.Zipify.OCU || { api: window.OCUApi };
        window.Zipify.OCU.api = window.Zipify.OCU.api || window.OCUApi;
        window.Zipify.OCU.api.customAllowUpsellsValidation = () => false;
        window.Zipify.OCU.api.excludeActionButton = 'phloe-lp-box';
      }

      guardSubscriptionWidget() {
        const strip = () => {
          this.querySelectorAll('.appstle_sub_widget:not([data-pl-appstle-bridge])').forEach((el) => el.remove());
          this.form.querySelectorAll('[name="selling_plan"]:not([data-pl-plan])').forEach((el) => el.remove());
        };
        strip();
        new MutationObserver(strip).observe(this, { childList: true, subtree: true });
      }
    }

    customElements.define('phloe-lp-box', PhloeLpBox);
  }

  if (!customElements.get('phloe-lp-gallery')) {
    class PhloeLpGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        if (root.hasAttribute('data-pl-landing')) this.setAttribute('data-view', 'product');
        this.setAttribute('data-ready', '');
        this.addEventListener('click', (evt) => {
          const btn = evt.target.closest('button[data-view]');
          if (btn && this.contains(btn)) this.show(btn.dataset.view);
        });
        document.addEventListener('on:phloe-lp:change', (evt) => {
          if (evt.detail.fromUser && evt.detail.keyChanged) this.setAttribute('data-view', 'product');
          this.sync();
        });
        this.sync();
      }

      show(view) {
        this.setAttribute('data-view', view);
        this.sync();
      }

      sync() {
        const key = currentKey();
        let view = this.getAttribute('data-view');
        const slides = [...this.querySelectorAll(`.pl-gallery__slide[data-slide="${view}"]`)];
        if (!slides.some((slide) => showsFor(slide, key))) {
          view = 'product';
          this.setAttribute('data-view', view);
        }
        this.querySelectorAll('.pl-gallery__thumb').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(btn.dataset.view === view));
        });
      }
    }

    customElements.define('phloe-lp-gallery', PhloeLpGallery);
  }

  if (!customElements.get('phloe-lp-sticky')) {
    class PhloeLpSticky extends HTMLElement {
      connectedCallback() {
        if (this.initialised || !('IntersectionObserver' in window)) return;
        this.initialised = true;

        this.cta = document.querySelector('phloe-lp-box [data-pl-cta]');
        this.closing = document.querySelector('[data-pl-closing-cta]');
        this.others = [...document.querySelectorAll('[data-pl-closing-cta], .cc-footer')];
        this.entries = new Map();
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.entries.set(entry.target, entry));
          this.update();
        });
        [this.cta, ...this.others].filter(Boolean).forEach((el) => observer.observe(el));
      }

      update() {
        const cta = this.entries.get(this.cta);
        const pastCta = Boolean(cta && !cta.isIntersecting && cta.boundingClientRect.top < 0);
        const otherVisible = this.others.some((el) => this.entries.get(el)?.isIntersecting);
        const show = pastCta && !otherVisible;
        if (show === !this.hidden) return;
        if (!show && this.contains(document.activeElement)) {
          // Keep focus near where the visitor is: the closing band's Buy button below, or the buy box's above.
          const closing = this.closing && this.closing.getClientRects().length ? this.closing : null;
          const target = !pastCta ? this.cta : closing || this.cta;
          if (target) target.focus({ preventScroll: true });
        }
        this.hidden = !show;
      }
    }

    customElements.define('phloe-lp-sticky', PhloeLpSticky);
  }
})();
